import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import type { PontoPendenciaComum } from '../solicitacoesDashboard.utils';

interface PendenciasComunsChartProps {
  dados: PontoPendenciaComum[];
}

export default function PendenciasComunsChart({ dados }: PendenciasComunsChartProps) {
  if (dados.length === 0) {
    return (
      <div className="rounded-lg border border-gray-200 bg-white p-6">
        <h3 className="mb-2 font-montserrat text-base font-semibold text-gray-900">Pendências Mais Comuns</h3>
        <p className="text-sm text-gray-400">Nenhuma pendência em aberto agora — tudo em dia.</p>
      </div>
    );
  }

  return (
    <div className="rounded-lg border border-gray-200 bg-white p-6">
      <h3 className="mb-1 font-montserrat text-base font-semibold text-gray-900">Pendências Mais Comuns</h3>
      <p className="mb-4 text-xs text-gray-400">Entre Solicitações Novo/Em Andamento agora — o que mais trava a conclusão.</p>
      <ResponsiveContainer width="100%" height={Math.max(220, dados.length * 36)}>
        <BarChart data={dados} layout="vertical" margin={{ left: 24 }}>
          <CartesianGrid strokeDasharray="3 3" stroke="#e5e7eb" />
          <XAxis type="number" allowDecimals={false} style={{ fontSize: '12px', fontFamily: 'Montserrat' }} stroke="#6b7280" />
          <YAxis
            type="category"
            dataKey="label"
            width={200}
            style={{ fontSize: '12px', fontFamily: 'Montserrat' }}
            stroke="#6b7280"
          />
          <Tooltip
            contentStyle={{ borderRadius: '8px', border: '1px solid #e5e7eb', fontFamily: 'Montserrat' }}
            formatter={(valor: number) => [valor, 'Solicitações']}
          />
          <Bar dataKey="quantidade" fill="#F59E0B" radius={[0, 6, 6, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
}
